import React from "react";
import { UiNavBar } from "../../component/_uiComponents/UiNavbar";
import { CloseIcon } from "../../../../styles/img/svg/CloseIcon";
import { Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { UiBackBreadcrumb } from "../../component/_uiComponents/UiBackBreadcrumb";
import { UiMobileBottomCard } from "../../component/_uiComponents/Dashboard/UiMobileBottomCard";
import { UiDashboardEmptyMessage } from "../../component/_uiComponents/ErrorMessages/UiEmptyScreens";
import emptyHistory from "../../../../styles/img/empty-account-activities.png";
import { UiCardWrapper } from "../../component/common/UiCardWrapper";

export const UiTransferEmpty = () => {
  const navigate = useNavigate();

  const backToHome = () => {
    navigate("/ui/dashboard");
  };
  const backFromForm = () => {
    navigate("/ui/bill-payments");
  };
  const closeForm = () => {
    navigate("/ui/dashboard");
  };

  return (
    <>
      <UiNavBar />

      <div className="df-user-profile">
        <Container maxWidth="md" className="df-pos-rel">
          <div className="df-user-profile__close-icon" onClick={backToHome}>
            <CloseIcon />
          </div>

          <div className="df-user-profile__body df-bill-payment-form">
            <div>
              <UiBackBreadcrumb
                backOnClick={backFromForm}
                TitleText="Transfer Limit Preferences"
              />

              <UiCardWrapper className="df-bill-payment-form__wrapper df-empty-settings">
                <UiDashboardEmptyMessage
                  icon={emptyHistory}
                  className=" df-empt-msg-acc df-empt-msg-history df-transfer-empty-screen"
                >
                  <h3>No transfer limits available</h3>
                  <p>Any limits set by the bank will be displayed here.</p>
                </UiDashboardEmptyMessage>
              </UiCardWrapper>
            </div>
          </div>
        </Container>
      </div>

      <UiMobileBottomCard />
    </>
  );
};
